import { combineAppReducer } from '@dpdgroupuk/ai-app';
import routePlannerApp from './routePlannerApp';
import routePlannerUser from './routePlannerUser';
import routesData from './routes';
import loader from './loader';
import route from './route';
import schedule from './schedule';
import map from './map';
import ui from './ui';
import modal from './modal';
import sectionsData from './sections';
import notifications from './notifications';

export default combineAppReducer({
  map,
  routePlannerApp,
  routePlannerUser,
  routesData,
  loader,
  route,
  appNotifications: notifications,
  schedule,
  ui,
  modal,
  sectionsData,
});
